<template>
    <el-dropdown @command="handlerSelete" class="lang-seletor">
        <i class="el-icon-question dropdown-img" style="margin:0;"></i>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in infoList" :key="item.path" :command="item.path">{{item.name}}</el-dropdown-item>
            <el-dropdown-item
                v-for="(item, index) in fixedInfoList"
                :key="item.name"
                :divided="!!infoList.length && !index"
                :command="item.name"
            >{{item.name}}</el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
import { I18nMixins, _$t } from '@/components/utils/i18n';

export default {
    mixins: [I18nMixins],
    data() {
        return {
            location: location
        };
    },
    props: {
        infoList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        fixedInfoList: {
            type: Array,
            default: () => {
                return [{
                    name: _$t('component.E1202104124669', { defaultText: '法律声明及隐私政策' }),
                    url: 'https://static.annto.com/res/webInfo/privacy.html'
                }, {
                    name: _$t('component.E1202104124670', { defaultText: '联系我们' }),
                    url: 'https://static.annto.com/res/webInfo/contact_us.html'
                }, {
                    name: _$t('component.E1202104124671', { defaultText: '服务条款' }),
                    url: 'https://static.annto.com/res/webInfo/service.html'
                }];
            }
        }
    },
    methods: {
        handlerSelete(command) {
            if (this.infoList.length) {
                this.infoList.forEach(item => {
                    if (command === item.path && item.openNewTagUrl) {
                        window.open(item.openNewTagUrl);
                    } else if (command === item.path) {
                        this.$router.push(item.path);
                    }
                });
            }
            this.fixedInfoList.forEach(item => {
                if (command === item.name && item.url) {
                    window.open(item.url);
                }
            });
        }
    }
};
</script>
<style lang="less">
    .lang-seletor {
        cursor: pointer;
        margin-right: 20px;
        display: flex;
        align-items: center;
        .dropdown-img{
            font-size: 20px;
            margin-right: 8px;
            &.auth-icon-message {
                display: block;
            }
        }
        .el-badge__content.is-fixed {
            right: 17px;
        }
    }
</style>
